import { Button, Classes, ControlGroup, IconName, InputGroup, Menu, MenuItem, NumericInput, Popover, Position } from "@blueprintjs/core";
import React from "react";

import { iDef } from "core/util/TypeUtils";
import BaseWidget from './BaseWidget';

interface IUnit {
	value: string;
	type: string;
}

const unitTypes = [ "px", "em", "vh", "vw", "fr", "%", "auto"];

export default class CssUnitWidget extends BaseWidget<IUnit, string, { icon?: IconName; }> {

	public render() {
		const { value, required, disabled, label, icon } = this.props;

		const unit = this.fromValue(value);

		const menuItems = unitTypes.map((t) =>
			<MenuItem key={t} text={t} onClick={(e) => this.onChange(unit, t, "type")} />
		);

		const typeMenu = (
			<Popover
				content = {
					<Menu>
						{menuItems}
					</Menu>
				}
				disabled={disabled}
				position={Position.BOTTOM_RIGHT}
			>
				<Button disabled={disabled} minimal={true}>
					{unit.type}
				</Button>
			</Popover>
		);

		/*
		if(label) {
			return (
				<ControlGroup fill={true}>
					<NumericInput
						leftIcon={icon}
						onValueChange={(v) => this.onChange(unit, v.toString(), "value")}
						value={parseInt(unit.value, 10)}
					/>
					{typeMenu}
				</ControlGroup>
			);
		}
		*/

		const group = <InputGroup
				type="number"
				leftIcon={icon}
				rightElement={typeMenu}
				value = { value == null ? "" : unit.value }
				required = { required }
				disabled = { disabled || "auto" === unit.type }
				placeholder = "number"
				onChange = {(e) => this.onChange(unit, e.target.value, "value")}
			/>;

		return group;
	}

	protected onChange(unit: IUnit, value: string, part: string) {
		const newUnit: IUnit = {...unit, [part]: value};

		if("auto" === newUnit.type) {
			this.props.onChange(newUnit.type);
		} else {
			this.props.onChange(this.toValue(newUnit));
		}
	}

	protected fromValue(value: string): IUnit {
		if("auto" === value) {
			return {value: "", type: "auto"};
		}

		const v = iDef(value) ? value : "0px";

		if (v.indexOf("%") > -1) {
			return {value: v.slice(0, -1), type: "%"};
		}

		// assume last two chars are unit
		// TODO parse properly
		return {value: v.slice(0, -2), type: v.slice(-2)};
	}

	protected toValue(unit: IUnit): string {
		return unit.value + unit.type;
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/CssUnitWidget.tsx